var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"env-wrap"},[_c('div',{staticClass:"minContent"},[_c('h3',[_vm._v("各等级耕地环境质量耕地面积分析")]),_vm._v(" "),_c('div',{ref:"chart1",staticClass:"echartsContent"})]),_vm._v(" "),_c('div',{staticClass:"minContent m20"},[_c('h3',[_vm._v("各等级耕地环境质量耕地占比分析")]),_vm._v(" "),_c('div',{ref:"chart2",staticClass:"echartsContent"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fe4ed38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quality/environment.vue
// module id = null
// module chunks = 